import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "jr-absolute jr-h-12 jr-box-border jr-bg-black jr-rounded jr-py-3 jr-px-5" }
const _hoisted_2 = { class: "jr-text-white jr-text-xs jr-font-bold" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "jr-absolute jr-border-6 jr-border-r-black jr-top-0 jr-bottom-0 jr--left-1 jr-h-0 jr-my-auto jr-transform jr-rotate-45" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _hoisted_3
  ]))
}